import { type MetricType } from 'features/charts-v2/types'
import { type TransformedDataPoint } from 'features/charts-v2/types/chart-strategy'

/**
 * Compute metric totals for all data points
 */
export const computeMetricTotals = (
  data: TransformedDataPoint[],
  selectedMetrics: MetricType[],
): Record<string, number> => {
  const metricsToTotal = new Set([
    ...selectedMetrics,
    'record_count',
    'sentence_count',
  ])
  const totals: Record<string, number> = {}
  metricsToTotal.forEach((metricType) => {
    totals[metricType] = data.reduce((sum, item) => {
      const value = item[`metric_${metricType}`] as number | undefined
      return sum + (value || 0)
    }, 0)
  })
  return totals
}
